import { useTheme as useNextTheme } from 'next-themes'
import { GrafbaseThemes } from 'style'

import { rudder } from 'lib/analytics/rudder'

type UseTheme = () => {
  themes: string[]
  forcedTheme?: string
  setTheme: (theme: GrafbaseThemes) => void
  theme?: GrafbaseThemes
  resolvedTheme?: string
  systemTheme?: 'dark' | 'light'
  isDarkTheme: boolean
}

export const useTheme: UseTheme = () => {
  const props = useNextTheme()

  return {
    ...props,
    isDarkTheme: props.resolvedTheme === 'dark',
    setTheme: async theme => {
      rudder?.track('Theme Changed', { theme })
      props.setTheme(theme)
    },
    theme: props?.theme as GrafbaseThemes,
  }
}
